<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-tabs vertical>
      <v-tab>Categories</v-tab>
      <v-tab-item>
        <category-views></category-views>
      </v-tab-item>
      <v-tab>XRefs</v-tab>
      <v-tab-item>
        <xref-views></xref-views>
      </v-tab-item>
      <v-tab>Profiles</v-tab>
      <v-tab-item>
        <profile-views></profile-views>
      </v-tab-item>
      <v-tab>Suburbs</v-tab>
      <v-tab-item>
        <suburb-views></suburb-views>
      </v-tab-item>
      <v-tab>Expiring Contracts</v-tab>
      <v-tab-item>
        <expiring-contract-views></expiring-contract-views>
      </v-tab-item>
      <v-tab>Text Messages</v-tab>
      <v-tab-item>
        <text-message-views></text-message-views>
      </v-tab-item>
      <v-tab>New Free Listings</v-tab>
      <v-tab-item>
        <new-free-listing-views></new-free-listing-views>
      </v-tab-item>
      <v-tab>New Priority Listings</v-tab>
      <v-tab-item>
        <new-priority-listing-views></new-priority-listing-views>
      </v-tab-item>
    </v-tabs>
  </v-row>
</template>

<script>
import CategoryViews from './CategoryViews'
import XrefViews from './XrefViews'
import ProfileViews from './ProfileViews'
import SuburbViews from './SuburbViews'
import NewFreeListingViews from './NewFreeListingViews'
import NewPriorityListingViews from './NewPriorityListingViews'
import ExpiringContractViews from './ExpiringContractViews'
import TextMessageViews from './TextMessageViews'
export default {
  components: {
    CategoryViews,
    XrefViews,
    ProfileViews,
    SuburbViews,
    NewFreeListingViews,
    NewPriorityListingViews,
    ExpiringContractViews,
    TextMessageViews
  }
}
</script>

<style lang="scss" scoped></style>
